import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useDeleteEvent = () => {
	const navigate = useNavigate()
	const {idx} = useParams()
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const clickEvent = () => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/event/${idx}`

		fetchRequest('DELETE', url)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				navigate(-1)
				break
			case 400:
				if (fetchResult?.data?.error_code === 'event_idx')
					setAlert('대회 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [clickEvent]
}

export default useDeleteEvent
